import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { UnsavedDiagramService } from '../diagram/unsaved-diagram.service';

export interface DiagramEditorDeactivate {
  canLeaveDiagramEditor: () => boolean | Promise<boolean>;
}

export const unsavedDiagramGuard: CanDeactivateFn<DiagramEditorDeactivate> = (component) => {
  const coord = inject(UnsavedDiagramService);
  if (!coord.editorActive() || !coord.hasUnsavedChanges()) {
    return true;
  }
  return component?.canLeaveDiagramEditor?.() ?? true;
};
